import React from 'react';
import { NotesEntityFields } from 'common/graphql/__generated__/NotesEntityFields';
import {
  TransactionNoteCreation,
  TransactionNoteCreationVariables,
} from './__generated__/TransactionNoteCreation';
import { NotesSectionProps } from 'common/components/NotesSection';
import { GenericNotesSection } from 'common/components/ActionMenu/Notes';

import ADD_NEW_NOTE from './TransactionNoteCreation.graphql';

type TransactionModalNotesSectionProps = Pick<
  NotesSectionProps,
  'listRefreshRequest'
> & {
  invoiceId: string;
  data: NotesEntityFields[];
  loading?: boolean;
};

export const TransactionModalNotesSection: React.FC<
  TransactionModalNotesSectionProps
> = ({ invoiceId, data, loading, listRefreshRequest }) => {
  return (
    <GenericNotesSection<
      Record<string, unknown>,
      TransactionNoteCreation,
      TransactionNoteCreationVariables
    >
      entityId={invoiceId}
      data={data}
      loading={loading}
      mutationDocument={ADD_NEW_NOTE}
      listRefreshRequest={listRefreshRequest}
    />
  );
};
